<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <!--<button class="btn btn-danger" @click="deleteItem(item)">{{ $t('buttons.delete') }}</button>-->
          <router-link :to="{ name: 'EXCMAgreementDeviceList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{$t('views.excmagreementdevice.show.title')}} {{ item && item['title'] }}</h4>
            </div>
            <div class="card-body">
              <b-row v-if="item">
                <b-tabs>
                  <b-tab :title="$t('views.excmagreementdevice.show.deviceDetails')" class="pt-4" active>
                    <b-col>
                      <p><b>{{$t('views.excmagreementdevice.show.name')}}:</b> {{ item.name }}</p>
                    </b-col>
                  </b-tab>
                  <b-tab :title="$t('views.excmagreementdevice.show.linkedCases')" class="pt-4"></b-tab>
                </b-tabs>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  computed: mapGetters({
    deleteError: 'excmagreementdevice/del/error',
    error: 'excmagreementdevice/show/error',
    isLoading: 'excmagreementdevice/show/isLoading',
    item: 'excmagreementdevice/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMAgreementDeviceShow')
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'excmagreementdevice/del/del',
      reset: 'excmagreementdevice/show/reset',
      retrieve: 'excmagreementdevice/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMAgreementDeviceList' }))
      }
    }
  }
}
</script>
